import { LegacyRef, forwardRef } from 'react';
import cx from 'classnames/bind';

import { getTextPoint } from '@/utils/getTextPoint';

import styles from './Notification.module.scss';

interface NotificationProps {
  points: number;
  className?: string;
}

const cn = cx.bind(styles);

const Notification = forwardRef(
  (
    { points, className }: NotificationProps,
    ref?: LegacyRef<HTMLDivElement>,
  ) => (
    <div ref={ref} className={cn('points', className)}>
      + {points}{' '}
      <span>{getTextPoint(points, ['балл', 'балла', 'баллов'])}</span>
    </div>
  ),
);

export default Notification;
